import * as Apollo from "@apollo/client";
import React from "react";

import { useContext } from "~/Context";
import * as Driver from "~/Driver";
import { DVIRs } from "~/DVIR";
import { Remote } from "~/Remote";

import { Errors as Errors_ } from "./Error";
import GeneratedFragments from "./Generated/Fragments";
import * as GeneratedTypes from "./Generated/Types";
import { Result as Result_ } from "./Result";

export { gql } from "@apollo/client";
export * as GraphQL from "graphql";

export type NativeError = Error;

export namespace Graph {
  export import Errors = Errors_;
  export import Generated = GeneratedTypes;
  export import Result = Result_;

  export const useClient = Apollo.useApolloClient;
  export const useQuery = Apollo.useQuery;
  export const useLazyQuery = Apollo.useLazyQuery;
  export const useMutation = Apollo.useMutation;

  export const Provider = ({
    children,
  }: {
    readonly children?: React.ReactNode;
  }) => {
    const context = useContext();
    const client = React.useMemo(
      () =>
        new Apollo.ApolloClient({
          cache: cache(),
          uri: `${context.api.baseURL}/drive`, //"http://localhost:8000/graphql",
          headers: { Authorization: `Bearer ${context.viewer.token}` },
          connectToDevTools: true,
        }),
      []
    );

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line functional/immutable-data
    window.apollo = client;

    return (
      <Apollo.ApolloProvider client={client}>{children}</Apollo.ApolloProvider>
    );
  };

  const cache = () =>
    new Apollo.InMemoryCache({
      ...GeneratedFragments,
      typePolicies: {
        ...Driver.Shifts.Query.typePolicies(),
        ...DVIRs.Query.typePolicies(),
        ...DVIRs.Summary.Query.typePolicies(),
      },
    });

  export type Response<A> =
    | Apollo.QueryResult<A>
    | Apollo.LazyQueryResult<A, unknown>
    | Apollo.MutationResult<A>;

  export namespace Response {
    export function toRemote<A>(response: Response<A>): Remote<A> {
      return response.data
        ? Remote.success(response.data)
        : response.loading
        ? Remote.loading()
        : response.error
        ? Remote.error(response.error)
        : Remote.idle();
    }
  }
}
